const _excluded = ["name", "style"],
  _excluded2 = ["size", "className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import Activity from './icons/Activity';
import AlertCircle from './icons/AlertCircle';
import AlertTriangle from './icons/AlertTriangle';
import ArrowDown from './icons/ArrowDown';
import ArrowLeft from './icons/ArrowLeft';
import ArrowRight from './icons/ArrowRight';
import ArrowUp from './icons/ArrowUp';
import AtSign from './icons/AtSign';
import BarChart from './icons/BarChart';
import Bell from './icons/Bell';
import Bitbucket from './icons/Bitbucket';
import Bold from './icons/Bold';
import BookOpenText from './icons/BookOpenText';
import Box from './icons/Box';
import BulletedList from './icons/BulletedList';
import Calendar from './icons/Calendar';
import Check from './icons/Check';
import ChevronDown from './icons/ChevronDown';
import ChevronRight from './icons/ChevronRight';
import Circle from './icons/Circle';
import CircleSlash from './icons/CircleSlash';
import Clock from './icons/Clock';
import Code from './icons/Code';
import CodeBlock from './icons/CodeBlock';
import Coffee from './icons/Coffee';
import Compass from './icons/Compass';
import Copy from './icons/Copy';
import Database from './icons/Database';
import Decap from './icons/Decap';
import Download from './icons/Download';
import Edit3 from './icons/Edit3';
import Edit from './icons/Edit';
import ExternalLink from './icons/ExternalLink';
import EyeOff from './icons/EyeOff';
import Eye from './icons/Eye';
import File from './icons/File';
import Files from './icons/Files';
import FileText from './icons/FileText';
import Film from './icons/Film';
import Filter from './icons/Filter';
import Flag from './icons/Flag';
import Folder from './icons/Folder';
import Form from './icons/Form';
import Github from './icons/Github';
import Gitlab from './icons/Gitlab';
import Globe from './icons/Globe';
import Grid from './icons/Grid';
import HardDrive from './icons/HardDrive';
import Heading from './icons/Heading';
import HeadingOne from './icons/HeadingOne';
import HeadingTwo from './icons/HeadingTwo';
import HeadingThree from './icons/HeadingThree';
import HelpCircle from './icons/HelpCircle';
import Image from './icons/Image';
import Inbox from './icons/Inbox';
import Info from './icons/Info';
import Italic from './icons/Italic';
import Layout from './icons/Layout';
import Link from './icons/Link';
import LoaderCircle from './icons/LoaderCircle';
import Lock from './icons/Lock';
import LogOut from './icons/LogOut';
import Mail from './icons/Mail';
import MapPin from './icons/MapPin';
import Maximize from './icons/Maximize';
import Maximize2 from './icons/Maximize2';
import Menu from './icons/Menu';
import Minimize from './icons/Minimize';
import Minus from './icons/Minus';
import Moon from './icons/Moon';
import MoreHorizontal from './icons/MoreHorizontal';
import MoreVertical from './icons/MoreVertical';
import Move from './icons/Move';
import Music from './icons/Music';
import Navigation from './icons/Navigation';
import Netlify from './icons/Netlify';
import NumberedList from './icons/NumberedList';
import Package from './icons/Package';
import Paperclip from './icons/Paperclip';
import Path from './icons/Path';
import Pentagon from './icons/Pentagon';
import PieChart from './icons/PieChart';
import Pin from './icons/Pin';
import PlusCircle from './icons/PlusCircle';
import Plus from './icons/Plus';
import Quote from './icons/Quote';
import Radio from './icons/Radio';
import Refresh from './icons/Refresh';
import Repeat from './icons/Repeat';
import Save from './icons/Save';
import Search from './icons/Search';
import Server from './icons/Server';
import Settings from './icons/Settings';
import Share2 from './icons/Share2';
import ShoppingCart from './icons/ShoppingCart';
import Sidebar from './icons/Sidebar';
import Square from './icons/Square';
import Star from './icons/Star';
import Sun from './icons/Sun';
import Trash2 from './icons/Trash2';
import Underline from './icons/Underline';
import Unsplash from './icons/Unsplash';
import UploadCloud from './icons/UploadCloud';
import Upload from './icons/Upload';
import User from './icons/User';
import Users from './icons/Users';
import Workflow from './icons/Workflow';
import X from './icons/X';
import Youtube from './icons/Youtube';
import Zap from './icons/Zap';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const iconComponents = {
  activity: Activity,
  'alert-circle': AlertCircle,
  'alert-triangle': AlertTriangle,
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  'at-sign': AtSign,
  'bar-chart': BarChart,
  bell: Bell,
  bitbucket: Bitbucket,
  bold: Bold,
  'book-open-text': BookOpenText,
  box: Box,
  'bulleted-list': BulletedList,
  calendar: Calendar,
  check: Check,
  'chevron-down': ChevronDown,
  'chevron-right': ChevronRight,
  circle: Circle,
  'circle-slash': CircleSlash,
  clock: Clock,
  code: Code,
  'code-block': CodeBlock,
  coffee: Coffee,
  compass: Compass,
  copy: Copy,
  database: Database,
  decap: Decap,
  download: Download,
  'edit-3': Edit3,
  edit: Edit,
  'external-link': ExternalLink,
  'eye-off': EyeOff,
  eye: Eye,
  file: File,
  files: Files,
  'file-text': FileText,
  film: Film,
  filter: Filter,
  flag: Flag,
  folder: Folder,
  form: Form,
  github: Github,
  gitlab: Gitlab,
  globe: Globe,
  grid: Grid,
  'hard-drive': HardDrive,
  heading: Heading,
  'heading-one': HeadingOne,
  'heading-two': HeadingTwo,
  'heading-three': HeadingThree,
  'help-circle': HelpCircle,
  image: Image,
  inbox: Inbox,
  info: Info,
  italic: Italic,
  layout: Layout,
  link: Link,
  'loader-circle': LoaderCircle,
  lock: Lock,
  'log-out': LogOut,
  mail: Mail,
  'map-pin': MapPin,
  maximize: Maximize,
  'maximize-2': Maximize2,
  menu: Menu,
  minimize: Minimize,
  minus: Minus,
  moon: Moon,
  'more-horizontal': MoreHorizontal,
  'more-vertical': MoreVertical,
  move: Move,
  music: Music,
  navigation: Navigation,
  netlify: Netlify,
  'numbered-list': NumberedList,
  package: Package,
  paperclip: Paperclip,
  path: Path,
  pentagon: Pentagon,
  'pie-chart': PieChart,
  pin: Pin,
  'plus-circle': PlusCircle,
  plus: Plus,
  quote: Quote,
  radio: Radio,
  refresh: Refresh,
  repeat: Repeat,
  save: Save,
  search: Search,
  server: Server,
  settings: Settings,
  'share-2': Share2,
  'shopping-cart': ShoppingCart,
  sidebar: Sidebar,
  square: Square,
  star: Star,
  sun: Sun,
  'trash-2': Trash2,
  underline: Underline,
  unsplash: Unsplash,
  'upload-cloud': UploadCloud,
  upload: Upload,
  user: User,
  users: Users,
  workflow: Workflow,
  x: X,
  youtube: Youtube,
  zap: Zap
};
function Icon(_ref) {
  let {
      name,
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const IconComponent = iconComponents[name] || iconComponents.x;
  return ___EmotionJSX(IconComponent, _extends({
    style: style
  }, props));
}
function SizedIcon(_ref2) {
  let {
      size,
      className = ''
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return ___EmotionJSX(Icon, _extends({}, props, {
    className: className,
    size: size === 'xs' ? '12' : size === 'sm' ? '16' : size === null || size === undefined || size === 'md' ? '20' : size === 'lg' ? '24' : size === 'xl' ? '32' : size
  }));
}
export default SizedIcon;